module.exports = __webpack_public_path__ + "static/media/preview.5db43ac1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lessonbuilder/preview.svg
// module id = 1036
// module chunks = 0